import React, { useState } from "react";
import "./header.css";
import "./animatedText.css";

import CTA from "./CTA";
import Me from "../../assets/me2023.png";
import LogoMe from "../../assets/logome4.png";
import "aos/dist/aos.css"; // You can also use <link> for styles
import { useTranslation } from "react-i18next";
import HeaderSocials from "./HeaderSocials";
import i18n from "../../languages/i18n";
import SlidingPane from "react-sliding-pane";
import MobileMenu from "../nav/MobileMenu";
import { HiOutlineMenu } from "react-icons/hi";

const Header = () => {
  const { t } = useTranslation();
  const [state, setState] = useState({
    isPaneOpen: false,
    isPaneOpenLeft: false,
  });
  console.log("Windows width:", window.innerWidth);

  return (
    <section className="customHeader area" id="home">
      <HiOutlineMenu
        size={35}
        className="mobile-burger"
        onClick={() => setState({ isPaneOpen: true })}
      />
      <div className="header_container">
        <div className="left">
          <div
            className="nameBlock"
            data-aos="fade-up"
            data-aos-duration="1500"
            dir={i18n.language === "ar" ? "rtl" : "ltr"}
          >
            <h5 className={i18n.language === "ar" && "arabicText"}>
              {t("welcome")}
            </h5>
            <h1 className={i18n.language === "ar" && "arabicTitle-h1"}>
              {t("myName")}
            </h1>
            <h3
              className={
                i18n.language === "ar" ? "text-light arabicText" : "text-light"
              }
            >
              {t("myJob")}
            </h3>
            <HeaderSocials />

            <CTA title1={t("dowloadCV-btn")} title2={t("letsTalk-btn")} />
          </div>

          <div className="animatedText">
            <div class="content" dir={i18n.language === "ar" ? "rtl" : "ltr"}>
              <div
                class="content__container"
                dir={i18n.language === "ar" ? "rtl" : "ltr"}
              >
                <p class="content__container__text">Remember </p>

                <ul class="content__container__list">
                  <li class="content__container__list__item">The only</li>
                  <li class="content__container__list__item">limits in life</li>
                  <li class="content__container__list__item">are the ones</li>
                  <li class="content__container__list__item finalText">
                    you make !
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="right">
          <div className="me" data-aos="fade-up" data-aos-duration="2000">
            <div className="logo">
             
              <img src={LogoMe} alt="Smichi Inc" />
            </div>

            <img src={Me} alt="me 2023" className="pic-me" />
          </div>
        </div>
      </div>

      <a
        href="#contact"
        className={
          i18n.language === "ar"
            ? "scroll_down arabicText scroll_down-rtl"
            : "scroll_down"
        }
      >
        {t("scrollDown-link")}
      </a>

      {/* For line animation 
      <div class="lines">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>*/}

      {/* For square animation */}
      <ul class="circles">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
      {
        <SlidingPane
          className="right-pane-container "
          overlayClassName="Overlay-container"
          isOpen={state.isPaneOpen}
          title="MSS"
          hideHeader
          onRequestClose={() => {
            // triggered on "<" on left top click or on outside click
            setState({ isPaneOpen: false });
          }}
          width={"20%"}
        >
          <MobileMenu />
        </SlidingPane>
      }
    </section>
  );
};

export default Header;

/*
  <div className="logo" data-aos="fade-up" data-aos-duration="1500">
  <img src={LogoMe} alt="Smichi Inc" />
</div>
}
*/
